"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.contactDetailsSchema = void 0;
const zod_1 = require("zod");
const userWithEmail_schema_1 = require("./userWithEmail.schema");
const userWithUserId_schema_1 = require("./userWithUserId.schema");
const contactWithInfoSchema = zod_1.z
    .object({
    firstName: zod_1.z.string().optional(),
    lastName: zod_1.z.string().optional(),
    fullName: zod_1.z.string().optional(),
    avatarUrl: zod_1.z.string().optional(),
})
    .merge(userWithUserId_schema_1.userWithUserIdSchema)
    .merge(userWithEmail_schema_1.userWithEmailSchema);
exports.contactDetailsSchema = zod_1.z.union([contactWithInfoSchema, userWithEmail_schema_1.userWithEmailSchema]);
//# sourceMappingURL=contactDetails.schema.js.map